import React, { Component } from "react";
import { appMethod as app } from '@utils/app';
import { Toast, Icon } from 'antd-mobile';
import "./TextAnimation.less";
import { Item } from "antd-mobile/lib/tab-bar";
class TextAnimation extends Component {
  state = {
    displayText: "",
    userInfo : app.getUserInfo(),
    propsData: null,
    isPlayingAudio:false,
    generateing: false,
    timer: null,
  };
  constructor(props){
    super(props)
    this.state.propsData = props.data;
  }
  componentDidMount() {
    // const { text, direction, isHistory } = this.props.data;
    const { text, direction, isHistory } = this.state.propsData;
    // console.log(this.props.data)
    let currentIndex = 0;
    if (direction != "reply" || isHistory) {
      this.setState({
        displayText: text,
      });
      return;
    }
    this.setState({
      generateing: true
    })
    const intervalId = setInterval(() => {
      if (currentIndex < text.length) {
        this.setState((prevState) => ({
          displayText: prevState.displayText + text[currentIndex],
        }));
        currentIndex++;
        // if(text[currentIndex] == '\n' || currentIndex%14 == 0){  // 换行时
          this.toBoxBottom();
        // }
      } else {
        clearInterval(intervalId);
        this.setState({
          generateing: false
        })
      }
    }, 40);
    this.setState({
      timer: intervalId
    })
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }
  //停止生成
  stopGenerate = () => {
    clearInterval(this.state.timer);
  }
  // 复制东西到剪切板
  setClipboardData = e => {
    let content = e.currentTarget.dataset.content
    app.setClipboardData({
      data: content
    })
    Toast.info('复制完成',1);
  }
  toPage = () => {
    app.turnToPage('userCenterComponentPage');
  }
  againSend = (e) => {
    let content = e.currentTarget.dataset.content
    this.props.againSend(content);
  }
  toBoxBottom = () => {
    this.props.toBoxBottom();
  }
  startShare = () => {
    this.props.startShare();
  }
  playAudio = async () => {
    console.log(window.speechSynthesis,'11111111111111')
    if (this.state.isPlayingAudio) {
      console.log('停止播放');
      // window.speechSynthesis.cancel()
      window.speechSynthesis.pause()
      console.log(window.speechSynthesis,'333333333')
      // this.setState((prevState) => ({
      //   isPlayingAudio: false,
      // }));
    }else{
      this.setState(() => ({
        isPlayingAudio: true,
      }));
      if ('speechSynthesis' in window) {
        await window.speechSynthesis.pause()
        await window.speechSynthesis.cancel()
        const utterance = new SpeechSynthesisUtterance(this.state.propsData.text);
        utterance.onend = () => {
          console.log("语音播放结束");
          this.setState((prevState) => ({
            isPlayingAudio: false,
          }))
          // 在这里执行其他操作
        };
        utterance.onpause = () => {
          this.setState((prevState) => ({
            isPlayingAudio: false,
          }))
          console.log("语音播放暂停", this.state.isPlayingAudio);
          // 在这里执行其他操作
        };
        // utterance.onboundary = (event) => {
        //   console.log(event,'utterance.onboundary');
        //   if (event.charIndex === 0 && !window.speechSynthesis.paused) {
        //     window.speechSynthesis.pause()
        //     console.log("上一个 utterance 被中断");
        //     // 在这里处理上一个 utterance 被中断时的逻辑
        //   }
        // }
        // window.speechSynthesis.cancel()
        setTimeout(() => {
          window.speechSynthesis.speak(utterance);
        }, 500);
        console.log(window.speechSynthesis,'222222222222222');
        
      }
      console.log('开始播放');
    }
    
  }
  // playAudio = () => {
  //   if ('speechSynthesis' in window) {
	// 	  const utterance = new SpeechSynthesisUtterance('要转化为语音的文本');
	// 	  window.speechSynthesis.speak(utterance);
	// 	}
	// }
  longPressStart = () => {
    !this.props.maskShow && this.props.longPressStart()
  }
  longPressEnd = () => {
    !this.props.maskShow && this.props.longPressEnd()
  }
  render() {
    const { displayText , userInfo, isPlayingAudio, generateing } = this.state;
    const { direction, noCopy, timeStr, isLoading, err, is_audio, isLongPress} = this.state.propsData;
    if (direction == "reply") {
      return (
        <div className="chat">
          <div className="chat-bubble-left">
            <div className="row fl_s">
              <img className="headimg" src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/log.png" alt="" />
              <div className={this.props.highLight?"chat-bubble-content highLight":"chat-bubble-content"}>
                {displayText}
                <div className="btn_list">
                  { is_audio == '1' && <div className="audio_play" onClick={this.playAudio}>
                    <img className="btn_item" src={`https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/${isPlayingAudio?'audio-stop-gray':'audio-play-gray'}.png`} alt="" />
                      { isPlayingAudio && 
                        <div className="record_animation">
                          <div className="spectrum_bar spectrum_bar1"></div>
                          <div className="spectrum_bar spectrum_bar2"></div>
                          <div className="spectrum_bar spectrum_bar3"></div>
                          <div className="spectrum_bar spectrum_bar4"></div>
                        </div>
                      }
                  </div>}
                <img className="mar-r16 btn_item" onClick={this.setClipboardData} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-copy-gray.png" alt="" />
                <img className="btn_item" onClick={this.startShare} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-gray.png" alt="" />
                </div>
              </div>
            </div>
            {/* {!noCopy && (<img className="copyimg" onClick={this.setClipboardData} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/copy.png" alt="" />)} */}
          </div>
          {generateing == true && <div className="stop_generate" onClick={this.stopGenerate}>停止生成</div>}
          {timeStr && (<div className="timetxt mar_l53">{timeStr}</div>)}
        </div>
      );
    }
    return (
      <div className="chat">
        <div className="chat-bubble-right">
          {isLoading && <Icon type="loading" />}
          {err && (<img className="copyimg" onClick={this.againSend} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/error.png" alt="" />)}
          {/* {!noCopy && !isLoading && !err && (<img className="copyimg" onClick={this.setClipboardData} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/copy.png" alt="" />)} */}
          <div className="row fl_s" onMouseDown={this.longPressStart} onMouseUp={this.longPressEnd} onTouchStart={this.longPressStart} onTouchEnd={this.longPressEnd}>
            <div className="chat-bubble-content">
              {this.props.isLongPress && <div className="pop">
                <div className="item" onClick={this.setClipboardData} data-content={displayText}><div className="icon" style={{backgroundImage:'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-copy-white.png)'}}></div>复制</div>
                <div className="item" onClick={this.startShare}><div className="icon" style={{backgroundImage:'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-white.png)'}}></div>分享</div>
              </div>}
              {displayText}
              { is_audio == '1' && <div className="btn_list">
                  { is_audio == '1' && <div className="audio_play" onClick={this.playAudio}>
                    <img className="btn_item" src={`https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/${isPlayingAudio?'audio-stop-white':'audio-play-white'}.png`} alt="" />
                      { isPlayingAudio && 
                        <div className="record_animation">
                          <div className="spectrum_bar_r spectrum_bar_r1"></div>
                          <div className="spectrum_bar_r spectrum_bar_r2"></div>
                          <div className="spectrum_bar_r spectrum_bar_r3"></div>
                          <div className="spectrum_bar_r spectrum_bar_r4"></div>
                        </div>
                      }
                  </div>}
                {/* <img className="mar-r16 btn_item" onClick={this.setClipboardData} data-content={displayText} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-copy-white.png" alt="" />
                <img className="btn_item" onClick={this.startShare} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-white.png" alt="" /> */}
                </div>}
            </div>
            <img className="headimg" onClick={this.toPage} src={userInfo.cover_thumb?userInfo.cover_thumb:'http://img.zhichiwangluo.com/zc_app_default_photo.png'} alt="" />
          </div>
        </div>
        {timeStr && (<div className="timetxt mar_r53">{timeStr}</div>)}
      </div>
    );
  }
}
export default TextAnimation;



// WEBPACK FOOTER //
// ./src/chatgpt-page/component/TextAnimation/TextAnimation.jsx